exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-a882f3c4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 2em 1em;\n  background: #fff;\n  min-height: 100%;\n}\n.sidebar[data-v-a882f3c4] {\n  width: 200px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  margin-right: 1em;\n}\n.right[data-v-a882f3c4] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n", ""]);

// exports
